import { createReducer, on } from "@ngrx/store";
import { ApuStandardActions } from "./apu-standard.actions";
import { apuStandardAdapter, initialApuStandardState } from "./apu-standard.state";

export const apuStandardReducer = createReducer(
    initialApuStandardState,
    on(ApuStandardActions.loadApuStandardSuccess, (state, action) => {
        return apuStandardAdapter.setAll(action.apuStandards, {
            ...state,
            errorMessage: null
        });
    }),
    on(ApuStandardActions.addApuStandardSuccess, (state, { apuStandard }) => {
        return apuStandardAdapter.addOne(apuStandard, {
            ...state,
            errorMessage: null
        });
    }),
    // upsertOne y no updateOne: el PUT devuelve la entidad completa y así el listado refleja
    // también los cambios de projectType/projectSubType sin recargar.
    on(ApuStandardActions.updateApuStandardSuccess, (state, { apuStandard }) => {
        return apuStandardAdapter.upsertOne(apuStandard, {
            ...state,
            errorMessage: null,
            currentApuStandard: state.currentApuStandard?.apuStandardId === apuStandard.apuStandardId
                ? apuStandard
                : state.currentApuStandard
        });
    }),
    on(ApuStandardActions.deleteApuStandardSuccess, (state, { apuStandardId }) => {
        return apuStandardAdapter.removeOne(apuStandardId, {
            ...state,
            errorMessage: null,
            currentApuStandard: state.currentApuStandard?.apuStandardId === apuStandardId
                ? null
                : state.currentApuStandard
        });
    }),
    on(
        ApuStandardActions.loadApuStandardFail,
        ApuStandardActions.addApuStandardFail,
        ApuStandardActions.updateApuStandardFail,
        ApuStandardActions.deleteApuStandardFail,
        ApuStandardActions.loadApuStandardByIdFail,
        (state, { error }) => ({ ...state, errorMessage: error })
    ),
    on(ApuStandardActions.setCurrentApuStandard, (state, { apuStandard }) => {
        return { ...state, currentApuStandard: apuStandard };
    })
);
